import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
  Tooltip,
} from "@mui/material";
import { Add } from "@mui/icons-material";
const PageContentLayoutTemplate = ({
  children,
  pageName,
  addcallbackFunction,
  tooltip,
}) => {
  return (
    <Card sx={{ mb: 3, p: 2, borderRadius: 2 }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h4">{pageName}</Typography>
          {tooltip ?(  <Tooltip title={tooltip}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={addcallbackFunction}
            >
              Add
            </Button>
          </Tooltip>): null}
          
        </Box>
        <Divider sx={{ my: 2 }} />
        {children}
      </CardContent>
    </Card>
  );
};

export default PageContentLayoutTemplate;
